import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"
const AboutImagesText = ({
  logo,
  title,
  text,
  fullImage,
  img2,
  mobileImage,
  smallDesc,
}) => {
  return (
    <Wraper img2={img2}>
      <div className="textSection aboutFontSize">
        <img
          src={logo}
          alt="logo"
          className={`${
            img2 ? "style2 aboutPageLogo logo" : " aboutPageLogo logo"
          } `}
        />
        <div className={`${img2 ? "img2" : "text"}`}>
          <h3 className="aboutPageTitle">{title}</h3>
          <p>{text}</p>
        </div>
      </div>
      <div className="image">
        <Img fluid={fullImage} className="fullImage" />
        <Img fluid={mobileImage} className="mobileImage" />
      </div>
    </Wraper>
  )
}

export default AboutImagesText
const Wraper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  flex-direction: ${props => (props.img2 ? "row-reverse" : "")};
  .textSection {
    margin-left: -8%;
    display: flex;
    width: 30%;
    justify-content: space-between;
    flex-direction: ${props => (props.img2 ? "row-reverse" : "")};
    align-items: center;
    text-align: end;
    border: 1px solid black;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.75);
    height: 150px;
    margin-right: -3%;
    z-index: 500;
    background: rgb(201, 199, 199, 0.8);
    padding: 20px 0;
    height: ${props => (props.img2 ? "auto" : "")};
    .logo {
      margin-left: -3%;
      margin-right: ${props => (props.img2 ? "-18%" : "")};
    }
    .style2 {
      display: flex;
      align-self: flex-start;
    }
    .text {
      margin-right: 6%;
    }
    .img2 {
      margin-right: 35px;
      h3 {
        margin: 0 16px;
      }
      p {
        line-height: 1.75;
      }
    }
  }
  .image {
    width: 60%;
    .mobileImage {
      display: none;
    }
  }
  @media (max-width: 1370px) {
    p {
      font-size: 1rem;
    }
  }
  @media (max-width: 1160px) {
    .textSection {
      width: 35%;
    }
  }
  @media (max-width: 1035px) {
    .textSection {
      width: 40%;
    }
  }
  @media (max-width: 962px) {
    .textSection {
      width: 40%;
    }
  }
  @media (max-width: 950px) {
    .textSection {
      margin-left: -20%;
      width: ${props => (props.img2 ? "50%" : "")};
    }
  }

  @media (max-width: 800px) {
    .image {
      .mobileImage {
        display: block;
      }
    }
    .fullImage {
      display: none;
    }
    .img2 {
      margin-right: 17px !important;
    }
  }
  @media (max-width: 650px) {
    .textSection {
      margin-right: -15%;
      width: 50%;
    }
  }
  @media (max-width: 380px) {
    .textSection {
      margin-left: ${props => (props.img2 ? "-30%" : "")};
      width: ${props => (props.img2 ? "58%" : " 50%")};
    }
  }
`
